/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEmailTemplateRequest
 */
export interface UpdateEmailTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateRequest
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the UpdateEmailTemplateRequest interface.
 */
export function instanceOfUpdateEmailTemplateRequest(value: object): value is UpdateEmailTemplateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function UpdateEmailTemplateRequestFromJSON(json: any): UpdateEmailTemplateRequest {
    return UpdateEmailTemplateRequestFromJSONTyped(json, false);
}

export function UpdateEmailTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmailTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'subject': json['subject'],
        'content': json['content'],
    };
}

export function UpdateEmailTemplateRequestToJSON(json: any): UpdateEmailTemplateRequest {
    return UpdateEmailTemplateRequestToJSONTyped(json, false);
}

export function UpdateEmailTemplateRequestToJSONTyped(value?: UpdateEmailTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'subject': value['subject'],
        'content': value['content'],
    };
}

